import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type UpdateProjectPrivacyMutationVariables = Types.Exact<{
  input: Types.UpdateProjectInput;
}>;


export type UpdateProjectPrivacyMutation = { __typename?: 'Mutation', updateProject?: { __typename?: 'UpdateProjectPayload', project?: { __typename?: 'Project', id: string, private: boolean } | null } | null };


export const UpdateProjectPrivacy = /*#__PURE__*/ gql`
    mutation UpdateProjectPrivacy($input: UpdateProjectInput!) {
  updateProject(input: $input) {
    project {
      id
      private
    }
  }
}
    ` as unknown as DocumentNode<UpdateProjectPrivacyMutation, UpdateProjectPrivacyMutationVariables>;

          

          export const useUpdateProjectPrivacyMutation = (options?:MutationHookOptions<UpdateProjectPrivacyMutation, UpdateProjectPrivacyMutationVariables>) => useMutation(UpdateProjectPrivacy, options);
          

          export type UpdateProjectPrivacyMutationOptions = MutationHookOptions<UpdateProjectPrivacyMutation, UpdateProjectPrivacyMutationVariables>;

          

          export type UpdateProjectPrivacyMutationResult = ReturnType<typeof useUpdateProjectPrivacyMutation>[1];

          
